import '../../../styles/fonts.css.js';
import React__default from 'react';
import { typographyTags } from './types.js';

const Typography = ({ tag, children, color }) => {
    const params = typographyTags[tag];
    return (React__default.createElement("div", { style: {
            fontFamily: 'Siemens',
            fontWeight: params.weight,
            fontStyle: params.italic ? 'italic' : 'normal',
            fontSize: params.size,
            letterSpacing: params.letterSpacing,
            textTransform: params.allCaps ? 'uppercase' : 'inherit',
            color: color || params.color || 'inherit',
        } }, children));
};

export { Typography as default };
//# sourceMappingURL=Typography.js.map
